import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Button from "../../../components/buttons/button";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import Select from "../../../components/select/select";
import { useEffect } from "react";
import * as yup from "yup";
import DateInput from "../../../components/inputs/dateInput";
const EditEmployee = ({ t, setOpen, selected }) => {
  const validationSchema = yup.object({
    name: yup.string().required(t("required")),
    email: yup.string().required(t("required")),
    job: yup.string().required(t("required")),
    salary: yup.string().required(t("required")),
    status: yup.string().required(t("required")),
    employmentDate: yup.string().required(t("required")),
    department: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      job: "",
      salary: "",
      status: "",
      department: "",
      employmentDate: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });
  useEffect(() => {
    if (selected) {
      formik.setFieldValue("name", selected.name);
      formik.setFieldValue("salary", selected.salary);
      formik.setFieldValue("employmentDate", selected.hireDate);
      formik.setFieldValue("email", selected.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);
  const { memberShipTypeOptions, addEmployeesStatusOptions } = useOptions();
  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div className="inputs">
        <TextInput formik={formik} name={"name"} label={t("fullName")} />
        <TextInput formik={formik} name={"email"} label={t("email")} />
      </div>

      <div className="inputs">
        <Select
          options={addEmployeesStatusOptions}
          formik={formik}
          name={"job"}
          label={t("job")}
        />
        <Select
          options={memberShipTypeOptions}
          formik={formik}
          name={"department"}
          label={t("department")}
        />
      </div>
      <div className="inputs">
        <TextInput formik={formik} name={"salary"} label={t("salary")} />
        <DateInput
          formik={formik}
          label={t("employmentDate")}
          name={"employmentDate"}
        />
      </div>
      <div>
        <Select
          options={addEmployeesStatusOptions}
          formik={formik}
          name={"status"}
          label={t("status")}
        />
      </div>

      <div className="flex items-center justify-end gap-3">
        <Button
          className={"border border-white text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
        <Button className={"bg-primary justify-center w-[130px] text-black text-sm"}>
          {t("save")}
        </Button>
      </div>
    </form>
  );
};

export default EditEmployee;
